console.log("🧯 jquery-ujs shim: disattivato");

export default {}; // niente, solo per bloccare l'import
